import { render, staticRenderFns } from "./SceneGallery.vue?vue&type=template&id=010cfb24&scoped=true&"
import script from "./SceneGallery.vue?vue&type=script&lang=js&"
export * from "./SceneGallery.vue?vue&type=script&lang=js&"
import style0 from "./SceneGallery.vue?vue&type=style&index=0&id=010cfb24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010cfb24",
  null
  
)

export default component.exports